/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

// Store functionality
import actions from './actions';
import getters from './getters';
import modules from './modules';
import mutations from './mutations';
import state from './state';

Vue.use(Vuex);

// Create a new store
const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
});

const plugins = [vuexLocal.plugin];

const store = new Vuex.Store({
  actions,
  getters,
  modules,
  mutations,
  state,
  plugins,
});

store.dispatch('hideToastMessage');

export default store;
